import React, { createContext, useState, useEffect } from 'react';
import { Route, useParams } from 'react-router-dom';

import ProductListExportView from 'components/product_lists/product_export/ProductListExportView';

const ProductListExportContext = createContext({});

// Export source type dictionary
export const EXPORT_SOURCE_TYPES = {
  PRODUCT_LIST: 'productList',
  DATA_SOURCE: 'dataSource',
};

function ProductListExportContainer() {
  const { productListId, dataSourceId } = useParams();
  const [attributes, setAttributes] = useState([]);
  const [selectedAttributes, setSelectedAttributes] = useState(addUniqueKey([]));
  const [isAGlobalAttribute, setIsAGlobalAttribute] = useState();
  const [exportSource, setExportSource] = useState({
    type: productListId ? EXPORT_SOURCE_TYPES.PRODUCT_LIST : EXPORT_SOURCE_TYPES.DATA_SOURCE,
    id: productListId || dataSourceId,
  });

  // Update the export source whenever params change
  useEffect(() => {
    setExportSource({
      type: productListId ? EXPORT_SOURCE_TYPES.PRODUCT_LIST : EXPORT_SOURCE_TYPES.DATA_SOURCE,
      id: productListId || dataSourceId,
    });
  }, [productListId, dataSourceId]);

  function addUniqueKey(objects) {
    return objects.map(obj => ({
      ...obj,
      uniqueKey: `${obj.attributeName}_${obj.isGlobalAttribute}`,
    }));
  }

  return (
    <ProductListExportContext.Provider
      value={{
        attributes,
        setAttributes,
        selectedAttributes,
        setSelectedAttributes,
        isAGlobalAttribute,
        setIsAGlobalAttribute,
        exportSource,
      }}
    >
      <Route path="/product-lists/:productListId/product-list-export" exact>
        <ProductListExportView />
      </Route>
      <Route path="/data-sources/:dataSourceId/product-export" exact>
        <ProductListExportView />
      </Route>
    </ProductListExportContext.Provider>
  );
}

export default ProductListExportContainer;
export { ProductListExportContext };
